<template>
  <div>
    <resource-download-button :resource="resource" />
    <p>
      <img
        class="img-thumbnail"
        :src="imageUrl"
        :alt="`${resource.title} resource thumbnail`">
    </p>
    <p class="description">{{ description }}</p>
    <resource-download-button :resource="resource" />
  </div>
</template>

<script>
import ResourceDownloadButton from '@/components/ResourceDownloadButton'

export default {
  name: 'ResourcePopoverPreview',
  components: {
    ResourceDownloadButton
  },
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  eventContext() {
    return {
      resource_preview_type: 'popover',
      resource_uuid: this.resource.uuid,
      resource_title: this.resource.title,
      resource_grades: this.resource.grades,
      resource_subjects: this.resource.subjects,
      resource_type: this.resource.type,
      resource_language: this.resource.language
    }
  },
  computed: {
    imageUrl() {
      return this.resource.thumbnail_url
    },
    description() {
      return this.resource.description
    }
  }
}
</script>

<style scoped>
.description {
  font-size: 85%;
  line-height: 16px;
}
.img-thumbnail {
  max-height: 190px;
}

::v-deep .btn-gb-light {
  margin: 6px 0;
}

::v-deep .btn-gb-light:focus,
::v-deep .btn-group.open .dropdown-toggle,
::v-deep .btn-gb-light.dropdown-toggle:active {
  outline: solid 2px #00141C;
  outline-offset: 2px;
}
</style>
